import React, { useContext } from 'react';
import { AccountContext, AccountProvider } from '~/accountContext';
import Navbar from '../Navbar';
import styles from './layout.module.scss';

const AuthApp = ({ children }: { children: React.ReactNode }) => {
  const { user } = useContext(AccountContext);
  return (
    <div className={styles.layout}>
      <Navbar />
      {user && (
        <div className={styles.pageContent}>{children}</div>
      )}
    </div>
  );
};

const Layout = ({ children }: { children: React.ReactNode }) => (
  <AccountProvider>
    <AuthApp>
      {children}
    </AuthApp>
  </AccountProvider>
);

export default Layout;
